import classNames from "classnames"
import { useRef, useState } from "react"

export default function Label({
  kind,
  label,
  description,
  htmlFor,
  required = false,
  variant = "stacked",
}) {
  const hasTooltip = kind !== undefined || description !== undefined

  const textRef = useRef(null)
  const [truncated, setTruncated] = useState(false)

  const handleMouseEnter = () => {
    const text = textRef.current
    setTruncated(text.scrollWidth > text.clientWidth)
  }

  const labelClasses = classNames(
    "group flex text-sm",
    variant === "inline"
      ? "min-w-32 grow basis-0 pt-1.5 text-neutral-6"
      : "relative mb-0.5 text-neutral-5",
    { "hover:text-primary-4 hover:cursor-pointer": hasTooltip }
  )

  return (
    <label
      htmlFor={htmlFor}
      className={labelClasses}
      onMouseEnter={handleMouseEnter}
      data-title={truncated ? label : undefined}
    >
      <span ref={textRef} className="min-w-0">
        {label}
      </span>
      {required && <span className="shrink-0">*</span>}
      {hasTooltip && (
        <div
          className={
            "invisible absolute left-2/4 top-full z-10 grid grid-cols-1 gap-y-2.5 rounded-md border-l-8 border-primary-9 bg-white p-2.5 text-neutral-3 shadow group-active:visible"
          }
          style={{
            width: "calc(100% - 2 * var(--margin-m) - 8px)",
            marginLeft: "calc(-1 * 50%)",
          }}
        >
          {kind && <div className="italic text-neutral-6">{kind}</div>}
          {description && <div>{description}</div>}
        </div>
      )}
    </label>
  )
}
